import { render, staticRenderFns } from "./setting-advanced-knowledge.vue?vue&type=template&id=617a87d5&"
import script from "./setting-advanced-knowledge.vue?vue&type=script&lang=js&"
export * from "./setting-advanced-knowledge.vue?vue&type=script&lang=js&"
import style0 from "./setting-advanced-knowledge.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports